module.exports = __webpack_public_path__ + "assets/img/home-form-bg.0ca58564.png";